export default __webpack_public_path__ + "static/media/ws_connect.1e3d2c1a.mp3";